

<p-confirmDialog />

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ summaryTableRows[0]?.count ?? 0 }}</span>
          <span class="stats-card-label">Total Work Logs</span>
          <span class="stats-card-sublabel">This period</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ summaryTableRows[1]?.count ?? 0 }}</span>
          <span class="stats-card-label">Approved</span>
          <span class="stats-card-sublabel">Fully reviewed</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-verified"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ summaryTableRows[2]?.count ?? 0 }}</span>
          <span class="stats-card-label">Submitted</span>
          <span class="stats-card-sublabel">Awaiting approval</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-send"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ summaryTableRows[3]?.count ?? 0 }}</span>
          <span class="stats-card-label">Draft</span>
          <span class="stats-card-sublabel">In progress</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-file-edit"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ summaryTableRows[4]?.count ?? 0 }}</span>
          <span class="stats-card-label">Not Entered</span>
          <span class="stats-card-sublabel">Action needed</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-exclamation-circle"></i></div>
      </div>
    </div>

    <!-- Filters -->
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field" *ngIf="!isCustomRangeActive">
          <label for="month" class="filter-label">Month</label>
          <p-select
            id="month"
            [(ngModel)]="selectedMonth"
            (ngModelChange)="onMonthYearChange()"
            [options]="months"
            optionLabel="label"
            optionValue="value"
            placeholder="Select month"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="!isCustomRangeActive">
          <label for="year" class="filter-label">Year</label>
          <p-select
            id="year"
            [(ngModel)]="selectedYear"
            (ngModelChange)="onMonthYearChange()"
            [options]="years"
            optionLabel="label"
            optionValue="value"
            placeholder="Select year"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="canUseCustomRange">
          <label for="periodMode" class="filter-label">Period Mode</label>
          <p-select
            id="periodMode"
            [(ngModel)]="selectedPeriodMode"
            (ngModelChange)="onPeriodModeChange()"
            [options]="periodModeOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="isCustomRangeActive">
          <label for="fromMonth" class="filter-label">From Month</label>
          <p-select
            id="fromMonth"
            [(ngModel)]="selectedFromMonth"
            (ngModelChange)="onRangeChange()"
            [options]="months"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="isCustomRangeActive">
          <label for="fromYear" class="filter-label">From Year</label>
          <p-select
            id="fromYear"
            [(ngModel)]="selectedFromYear"
            (ngModelChange)="onRangeChange()"
            [options]="years"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="isCustomRangeActive">
          <label for="toMonth" class="filter-label">To Month</label>
          <p-select
            id="toMonth"
            [(ngModel)]="selectedToMonth"
            (ngModelChange)="onRangeChange()"
            [options]="months"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field" *ngIf="isCustomRangeActive">
          <label for="toYear" class="filter-label">To Year</label>
          <p-select
            id="toYear"
            [(ngModel)]="selectedToYear"
            (ngModelChange)="onRangeChange()"
            [options]="years"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-multiSelect
            id="serviceGroupFilter"
            [(ngModel)]="selectedServiceGroupIds"
            (ngModelChange)="onServiceGroupFilterChange()"
            [options]="serviceGroupOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search service group..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="projectFilter" class="filter-label">Project</label>
          <p-multiSelect
            id="projectFilter"
            [(ngModel)]="selectedProjectIds"
            (ngModelChange)="onProjectFilterChange()"
            [options]="projectFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search project..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-multiSelect
            id="statusFilter"
            [(ngModel)]="selectedStatuses"
            (ngModelChange)="onStatusFilterChange()"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="totalHoursFilter" class="filter-label">Total Hours</label>
          <p-multiSelect
            id="totalHoursFilter"
            [(ngModel)]="selectedTotalHoursThresholds"
            (ngModelChange)="onTotalHoursFilterChange()"
            [options]="totalHoursFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

      </div>

      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [value]="rows"
      [loading]="loading"
      dataKey="employeeId"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="20"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} timesheets"
      [resizableColumns]="true"
      columnResizeMode="expand"
      persistColumnWidths="work-log-report"
      [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
      styleClass="p-datatable no-column-lines compact-striped-table resize-handles-visible timesheet-report-table">
      <!-- Fixed px widths sized to actual content, with Employee left to absorb the
           slack. Percentages spread the surplus across every column, which left the
           numeric and action cells far wider than the values inside them. -->
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 44px">
          <col style="width: 52px">
          <col>
          <col style="width: 92px">
          <col style="width: 92px">
          <col style="width: 92px">
          <col style="width: 92px">
          <col style="width: 92px">
          <col style="width: 104px">
          <col style="width: 128px">
          <col style="width: 132px">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="th-toggle"></th>
          <th>#</th>
          <th pResizableColumn>Employee</th>
          <th pResizableColumn class="text-center">W1</th>
          <th pResizableColumn class="text-center">W2</th>
          <th pResizableColumn class="text-center">W3</th>
          <th pResizableColumn class="text-center">W4</th>
          <th pResizableColumn class="text-center">W5</th>
          <th pResizableColumn class="text-center">Total</th>
          <th pResizableColumn class="text-center">Status</th>
          <th class="th-actions text-left">Action</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-expanded="expanded">
        <tr [ngClass]="{'row-zero-hours': isZeroTotalHours(row) || hasAnyZeroHoursProject(row)}">
          <td>
            <span [pRowToggler]="row" class="row-expand-toggler" [attr.title]="expanded ? 'Collapse' : 'Expand project-wise view'">
              <i [class]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
            </span>
          </td>
          <td>{{ rowIndex + 1 }}</td>
          <td>
            <a class="employee-link" (click)="openSummary(row)"
              pTooltip="View timesheet summary" tooltipPosition="top">{{ row.employeeName }}</a>
          </td>
          <td class="text-center time-cell">{{ formatHoursMinutes(row.week1Hours) }}</td>
          <td class="text-center time-cell">{{ formatHoursMinutes(row.week2Hours) }}</td>
          <td class="text-center time-cell">{{ formatHoursMinutes(row.week3Hours) }}</td>
          <td class="text-center time-cell">{{ formatHoursMinutes(row.week4Hours) }}</td>
          <td class="text-center time-cell">{{ formatHoursMinutes(row.week5Hours) }}</td>
          <td class="text-center time-cell">{{ getFormattedRowTotal(row) }}</td>
          <td class="text-center">
            <p-tag [value]="getStatusLabel(row)" [severity]="getStatusSeverity(row)"></p-tag>
          </td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              @if (canUseEmployeeRowActions && canApproveTimesheet && (!row.timesheet?.id || row.timesheet?.id === '')) {
                <p-button
                  icon="pi pi-envelope"
                  severity="warn"
                  (onClick)="sendTimesheetReminder(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Send Reminder"
                  tooltipPosition="top" />
              }
              @if (canUseEmployeeRowActions && canApproveTimesheet && row.timesheet?.id && !row.isSubmitted && !row.isApproved) {
                <p-button
                  icon="pi pi-send"
                  severity="primary"
                  (onClick)="submitTimesheet(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Submit"
                  tooltipPosition="top" />
              }
              @if (canUseEmployeeRowActions && row.isSubmitted && !row.isApproved && canApproveTimesheet) {
                <p-button
                  icon="pi pi-check"
                  severity="success"
                  (onClick)="approveTimesheet(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Approve"
                  tooltipPosition="top" />
                <p-button
                  icon="pi pi-undo"
                  severity="warn"
                  (onClick)="revertToDraft(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Revert to Draft"
                  tooltipPosition="top" />
              }
              @if (canUseEmployeeRowActions && row.isApproved && canApproveTimesheet) {
                <p-button
                  icon="pi pi-undo"
                  severity="warn"
                  (onClick)="revertToDraft(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Revert to Draft"
                  tooltipPosition="top" />
              }
              @if (canUseEmployeeRowActions) {
                <p-button
                  icon="pi pi-eye"
                  severity="info"
                  (onClick)="viewTimesheet(row)"
                  [text]="true"
                  size="small"
                  pTooltip="View"
                  tooltipPosition="top" />
                <p-button
                  icon="pi pi-file-excel"
                  severity="success"
                  (onClick)="exportEmployeeTimesheetToExcel(row)"
                  [text]="true"
                  size="small"
                  pTooltip="Download"
                  tooltipPosition="top" />
              }
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-row>
        <tr class="expansion-row">
          <td [attr.colspan]="11" class="p-0">
            <div class="expansion-content">
              <p-table [value]="row.expandedProjectRows" [tableStyle]="{ 'min-width': '100%' }" styleClass="p-datatable-gridlines p-datatable-sm compact-overlay-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 30%">Project</th>
                    <th style="width: 20%">PM</th>
                    <th style="width: 8%">W1</th>
                    <th style="width: 8%">W2</th>
                    <th style="width: 8%">W3</th>
                    <th style="width: 8%">W4</th>
                    <th style="width: 8%">W5</th>
                    <th style="width: 10%">Total</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-projectRow>
                  <tr [ngClass]="{'row-zero-hours': isProjectZeroHours(projectRow)}">
                    <td>{{ projectRow.projectName }}</td>
                    <td>{{ projectRow.pmName }}</td>
                    <td class="time-cell">{{ formatHoursMinutes(projectRow.week1Hours) }}</td>
                    <td class="time-cell">{{ formatHoursMinutes(projectRow.week2Hours) }}</td>
                    <td class="time-cell">{{ formatHoursMinutes(projectRow.week3Hours) }}</td>
                    <td class="time-cell">{{ formatHoursMinutes(projectRow.week4Hours) }}</td>
                    <td class="time-cell">{{ formatHoursMinutes(projectRow.week5Hours) }}</td>
                    <td class="time-cell">{{ formatTotalHours(projectRow.totalHours) }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="8" class="text-center">No project breakdown (no allocations or entries).</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="11" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No work logs found</p>
              <p class="empty-description">Try changing the month, year or clearing filters</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Timesheet Summary popup (counts by status) -->
<p-dialog
  header="Work Log Summary"
  [(visible)]="showTimesheetSummaryDialog"
  [modal]="true"
  styleClass="dialog-md"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeTimesheetSummaryDialog()">
  <div class="ts-summary-compact-grid">
    <div class="ts-summary-stat ts-summary-stat--neutral">
      <div class="ts-summary-stat-icon-wrap"><i class="pi pi-users ts-summary-stat-icon"></i></div>
      <div class="ts-summary-stat-value">{{ summaryTableRows[0]?.count ?? 0 }}</div>
      <div class="ts-summary-stat-label">Total</div>
    </div>
    <div class="ts-summary-stat ts-summary-stat--success">
      <div class="ts-summary-stat-icon-wrap"><i class="pi pi-verified ts-summary-stat-icon"></i></div>
      <div class="ts-summary-stat-value">{{ summaryTableRows[1]?.count ?? 0 }}</div>
      <div class="ts-summary-stat-label">Approved</div>
    </div>
    <div class="ts-summary-stat ts-summary-stat--info">
      <div class="ts-summary-stat-icon-wrap"><i class="pi pi-send ts-summary-stat-icon"></i></div>
      <div class="ts-summary-stat-value">{{ summaryTableRows[2]?.count ?? 0 }}</div>
      <div class="ts-summary-stat-label">Submitted</div>
    </div>
    <div class="ts-summary-stat ts-summary-stat--warning">
      <div class="ts-summary-stat-icon-wrap"><i class="pi pi-file-edit ts-summary-stat-icon"></i></div>
      <div class="ts-summary-stat-value">{{ summaryTableRows[3]?.count ?? 0 }}</div>
      <div class="ts-summary-stat-label">Draft</div>
    </div>
    <div class="ts-summary-stat ts-summary-stat--danger">
      <div class="ts-summary-stat-icon-wrap"><i class="pi pi-exclamation-circle ts-summary-stat-icon"></i></div>
      <div class="ts-summary-stat-value">{{ summaryTableRows[4]?.count ?? 0 }}</div>
      <div class="ts-summary-stat-label">Not Entered</div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" severity="secondary" (onClick)="closeTimesheetSummaryDialog()" />
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showSummaryDialog"
  [modal]="true"
  styleClass="dialog-lg"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeSummary()">
  <ng-template pTemplate="header">
    <div class="summary-header">
      <div>
        <div class="summary-title">Work Log Summary</div>
        <div class="summary-subtitle">{{ selectedEmployeeRow?.employeeName }}</div>
      </div>
      <div class="summary-header-actions">
        @if (canUseEmployeeRowActions) {
          <p-button
            label="View"
            icon="pi pi-eye"
            severity="info"
            (onClick)="selectedEmployeeRow && viewTimesheet(selectedEmployeeRow)"
            [outlined]="true"
            size="small" />
          <p-button
            label="Download Timesheet"
            icon="pi pi-file-excel"
            severity="success"
            (onClick)="selectedEmployeeRow && exportEmployeeTimesheetToExcel(selectedEmployeeRow)"
            [outlined]="true"
            size="small" />
        }
      </div>
    </div>
  </ng-template>

  <div *ngIf="selectedEmployeeRow">
    <!-- Compact weekly metric strip -->
    <div class="popup-metric-strip">
      <div class="popup-metric-item popup-metric-item--total">
        <span class="popup-metric-label">Total</span>
        <span class="popup-metric-value">{{ getFormattedRowTotal(selectedEmployeeRow) }}</span>
      </div>
      <div class="popup-metric-item">
        <span class="popup-metric-label">W1</span>
        <span class="popup-metric-value">{{ formatHoursMinutes(selectedEmployeeRow.week1Hours) }}</span>
      </div>
      <div class="popup-metric-item">
        <span class="popup-metric-label">W2</span>
        <span class="popup-metric-value">{{ formatHoursMinutes(selectedEmployeeRow.week2Hours) }}</span>
      </div>
      <div class="popup-metric-item">
        <span class="popup-metric-label">W3</span>
        <span class="popup-metric-value">{{ formatHoursMinutes(selectedEmployeeRow.week3Hours) }}</span>
      </div>
      <div class="popup-metric-item">
        <span class="popup-metric-label">W4</span>
        <span class="popup-metric-value">{{ formatHoursMinutes(selectedEmployeeRow.week4Hours) }}</span>
      </div>
      <div class="popup-metric-item">
        <span class="popup-metric-label">W5</span>
        <span class="popup-metric-value">{{ formatHoursMinutes(selectedEmployeeRow.week5Hours) }}</span>
      </div>
      <div class="popup-metric-item popup-metric-item--status">
        <span class="popup-metric-label">Status</span>
        <p-tag [value]="getStatusLabel(selectedEmployeeRow)" [severity]="getStatusSeverity(selectedEmployeeRow)" />
      </div>
    </div>

    <!-- Project breakdown table with weekly hours -->
    <p-table
      [value]="projectSummary"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines compact-striped-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 26%">Project</th>
          <th style="width: 18%">PM</th>
          <th style="width: 8%" class="text-right">W1</th>
          <th style="width: 8%" class="text-right">W2</th>
          <th style="width: 8%" class="text-right">W3</th>
          <th style="width: 8%" class="text-right">W4</th>
          <th style="width: 8%" class="text-right">W5</th>
          <th style="width: 16%" class="text-right">Total</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [ngClass]="{'row-zero-hours': isProjectZeroHours(row)}">
          <td>{{ row.projectName }}</td>
          <td>{{ row.pmName }}</td>
          <td class="text-right time-cell">{{ formatHoursMinutes(row.week1Hours) }}</td>
          <td class="text-right time-cell">{{ formatHoursMinutes(row.week2Hours) }}</td>
          <td class="text-right time-cell">{{ formatHoursMinutes(row.week3Hours) }}</td>
          <td class="text-right time-cell">{{ formatHoursMinutes(row.week4Hours) }}</td>
          <td class="text-right time-cell">{{ formatHoursMinutes(row.week5Hours) }}</td>
          <td class="text-right time-cell">{{ formatTotalHours(row.totalHours) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center">No entries.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" severity="secondary" (onClick)="closeSummary()" />
  </ng-template>
</p-dialog>

